import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/auth-provider";

export function ProtectedRoute() {
	const { isAuthenticated } = useAuth();
	const location = useLocation();
	if (!isAuthenticated) {
		const next =
			location.pathname === "/"
				? ""
				: `?next=${encodeURIComponent(location.pathname + location.search)}`;
		return <Navigate to={`/login${next}`} replace />;
	}
	return <Outlet />;
}
